import { BaseModel } from '../base-model';

export interface IDemandRegion { }
export class DemandRegion extends BaseModel<IDemandRegion> implements IDemandRegion {
  /**
   *
   */
  constructor(option?: IDemandRegion) {
    super(option);
  }
}